/**
 * @file wq-activity-tracker.js
 * @description Frontend activity event tracking — tracks product views,
 *              calculator usage, and AI chat interactions. Fire-and-forget
 *              pattern: never blocks user interaction.
 * @sprint Phase 4
 */
window.WQ = window.WQ || {};

window.WQ.ActivityTracker = (function () {
  'use strict';

  var API_URL = 'https://wq-ai-concierge.chengliu1130.workers.dev/api/events';
  var PRODUCT_VIEW_KEY = 'wq_product_views';
  var PRODUCT_VIEW_THRESHOLD = 10;

  var _customerId = null;
  var _customerEmail = null;

  /**
   * Initialize tracker with customer identity and start passive listeners.
   * @param {string} customerId  - Shopify customer ID
   * @param {string} customerEmail - Shopify customer email
   */
  function init(customerId, customerEmail) {
    _customerId = customerId || null;
    _customerEmail = customerEmail || null;

    trackProductView();
    trackCalculatorUsage();
  }

  /**
   * Send an event to the backend. Fire-and-forget — errors are silently caught.
   * @param {string} eventType - Event type identifier
   * @param {Object} payload   - Arbitrary event data
   */
  function sendEvent(eventType, payload) {
    if (!_customerId) return;

    try {
      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customer_id: _customerId,
          customer_email: _customerEmail,
          event_type: eventType,
          payload: payload || {}
        })
      }).catch(function () {});
    } catch (e) {
      // silent
    }
  }

  /**
   * Track product page views. Increments a sessionStorage counter and fires
   * a `product_views_10` event when the threshold is reached.
   */
  function trackProductView() {
    // Only run on product pages
    if (typeof window.ShopifyAnalytics === 'undefined' ||
        !window.ShopifyAnalytics.meta ||
        window.ShopifyAnalytics.meta.page_type !== 'product') {
      return;
    }

    var count = parseInt(sessionStorage.getItem(PRODUCT_VIEW_KEY) || '0', 10);
    count += 1;
    sessionStorage.setItem(PRODUCT_VIEW_KEY, String(count));

    if (count === PRODUCT_VIEW_THRESHOLD) {
      sendEvent('product_views_10', { count: count });
    }
  }

  /**
   * Listen for calculator result messages (postMessage from calculator iframes)
   * and send a `calculator_used` event.
   */
  function trackCalculatorUsage() {
    window.addEventListener('message', function (e) {
      if (e.data && e.data.type === 'wq:calc-result') {
        sendEvent('calculator_used', {
          calculator: e.data.calculator || '',
          params: e.data.params || {}
        });
      }
    });
  }

  return {
    init: init,
    sendEvent: sendEvent,
    trackProductView: trackProductView,
    trackCalculatorUsage: trackCalculatorUsage
  };
})();
